import React, { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { routesConstants } from "../utils/constants";
import { useSelector } from "react-redux";
import { RootState } from "../services/redux/store";

const AuthProtectedRoute: React.FC<
  PropsWithChildren<{
    children: React.ReactNode;
  }>
> = ({ children }) => {
  const { login_data, userProfile_data } = useSelector(
    (store: RootState) => store.authStore
  );

  return login_data.token ? (
    userProfile_data.isProfileUpdated ? (
      <>{children}</>
    ) : (
      <Navigate to={routesConstants.updateProfile} />
    )
  ) : (
    <Navigate to={routesConstants.login} />
  );
};

export default AuthProtectedRoute;
